import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import type { IAction } from '@ztechapps/common.contract'
import { AssessmentTypeEnum } from '../enums/AssessmentTypeEnum'

@InputType()
export class SetQuickscoreScanModelArgs extends ActionArgs {
  @Field(() => AssessmentTypeEnum)
  assessmentType: AssessmentTypeEnum

  /** The model id to make active for this assessment type; omitted or unset clears back to the deploy-time fallback. */
  @Field(() => String, { nullable: true })
  model?: string
}

export interface ISetQuickscoreScanModel extends IAction<boolean, SetQuickscoreScanModelArgs> {}
